import React from 'react';

import PriceFilterByPriceType from '../PriceFilterByPriceType/PriceFilterByPriceType';
import PriceInputsWrapper from '../PriceInputsWrapper/PriceInputsWrapper';
import type {FilterGroupContentProps} from '../FilterGroupContent/FilterGroupContent';

type Props = Pick<
    FilterGroupContentProps,
    | 'currency'
    | 'customFiltersParams'
    | 'onCustomFilterUpdate'
    | 'priceFilterOptions'
    | 'priceInputValuesAreValid'
    | 'updatePriceInputValuesValidity'
>;

export type BoundsType = Array<number | null>;

export default function PriceFilter(props: Props) {
    const {
        customFiltersParams,
        onCustomFilterUpdate,
        priceFilterOptions = {},
    } = props;
    const {
        appliedMinTotalPrice,
        appliedMaxTotalPrice,
        selectedMinTotalPrice,
        selectedMaxTotalPrice,
        appliedMinNightlyPrice,
        appliedMaxNightlyPrice,
        selectedMinNightlyPrice,
        selectedMaxNightlyPrice,
        selectedFilterByTotalPrice,
    } = customFiltersParams;

    const handleFilterByPriceTypeChange = (filterByTotalPrice) => {
        onCustomFilterUpdate({filterByTotalPrice});
    };

    const handleTotalPriceChange = ({minPrice, maxPrice}, inputType) => {
        onCustomFilterUpdate({
            minTotalPrice: minPrice,
            maxTotalPrice: maxPrice,
            priceEventData: {
                inputType,
            },
        });
    };

    const handleNightlyPriceChange = ({minPrice, maxPrice}, inputType) => {
        onCustomFilterUpdate({
            minNightlyPrice: minPrice,
            maxNightlyPrice: maxPrice,
            priceEventData: {
                inputType,
            },
        });
    };

    return (
        <div
            role="menuitem"
            aria-labelledby="filter-group-label-PriceFilter"
            className="PriceFilter"
        >
            {!!priceFilterOptions.showFilterByPriceType && (
                <PriceFilterByPriceType
                    isFilterByTotalPriceSelected={selectedFilterByTotalPrice}
                    isFilterByTotalPriceEnabled={
                        !!priceFilterOptions.isFilterByTotalPriceEnabled
                    }
                    onChange={handleFilterByPriceTypeChange}
                />
            )}

            {selectedFilterByTotalPrice && (
                <PriceInputsWrapper
                    {...props}
                    appliedMinPrice={appliedMinTotalPrice}
                    appliedMaxPrice={appliedMaxTotalPrice}
                    selectedMinPrice={selectedMinTotalPrice}
                    selectedMaxPrice={selectedMaxTotalPrice}
                    filterByTotalPrice={selectedFilterByTotalPrice}
                    onInputsWrapperPriceChange={handleTotalPriceChange}
                />
            )}

            {!selectedFilterByTotalPrice && (
                <PriceInputsWrapper
                    {...props}
                    appliedMinPrice={appliedMinNightlyPrice}
                    appliedMaxPrice={appliedMaxNightlyPrice}
                    selectedMinPrice={selectedMinNightlyPrice}
                    selectedMaxPrice={selectedMaxNightlyPrice}
                    filterByTotalPrice={selectedFilterByTotalPrice}
                    onInputsWrapperPriceChange={handleNightlyPriceChange}
                />
            )}
        </div>
    );
}
